import React, { ReactNode } from 'react';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { TextButton } from '../TextButton/TextButton';
import { useStore } from '../../lib/store/store';
import useDevice from '../../lib/utils/hooks/useDevice';
import { SmallButton } from '../SmallButton/SmallButton';

type Props = {
	to: string;
	children?: ReactNode;
};

export default function BackButton({ to, children }: Props) {
	const lastRoute = useStore(state => state.lastRoute);
	const router = useRouter();

	const { isPhone } = useDevice();

	const getButton = () => {
		if (isPhone) {
			return (
				<div className='mt-1 mb-2'>
					<SmallButton
						secondary
						onClick={() => {}}
						icon={faChevronLeft}
						iconPosition='left'
						ariaLabel='Back'
						id='backButton'
					>
						Back
					</SmallButton>
				</div>
			);
		}

		return (
			<TextButton
				white={false}
				onClick={() => {}}
				icon={faChevronLeft}
				id='BackButton'
			>
				Back
			</TextButton>
		);
	};

	const child = children || getButton();

	if (lastRoute) {
		return (
			<div className='w-20' onClick={router.back}>
				{child}
			</div>
		);
	}

	return (
		<div className='w-20'>
			<Link href={to} passHref>
				<a>{child}</a>
			</Link>
		</div>
	);
}
